module.exports = __webpack_public_path__ + "media/theme/sample-card__recochoku-5c3aaafa.jpg";